import {
  PiSmileyAngry,
  PiSmileyMeh,
  PiSmileySad,
  PiSmileyLight,
} from "react-icons/pi";
import { AiOutlineSmile } from "react-icons/ai";

export const GradeList = [
  <PiSmileyAngry />,
  <PiSmileySad />,
  <PiSmileyMeh />,
  <PiSmileyLight />,
  <AiOutlineSmile />,
];
